import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { useSelector } from "react-redux";
import { Table, Input, Button, Space, message } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined, EditOutlined } from "@ant-design/icons";
import { TitlePage } from "../../../../TitlePage";

//Floating Buttons
import FloatingButtons from "react-floating-buttons";
import newRec from "../../../../../assets/icons/file-edit-outline.svg";
import backHome from "../../../../../assets/icons/home-outline.svg";

//Importacion del form
import VntFormasPagoForm from "./VntFormasPagoForm";

//Importaciones propias
import ModalApp from "../../../../Modal";
import { colorPrm } from "../../../../../constants";

/**
 * Cuentas Bancarias la Lista que está seteada en el State
 */
export default function VntFormasPago() {
  const vntformapago = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.vntformapago
  );
  const currentUser = useSelector(
    (state) => state.currentUser.currentUser.user_data
  );
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [record, setRecord] = useState(null);
  const history = useHistory();

  //Definicion de los floating
  const buttonsList = [
    {
      onClick: () => history.push(`/${currentUser.pagina}`),
      src: backHome,
      style: { color: "red" },
    },
    {
      onClick: () => openModal(null),
      src: newRec,
    },
  ];
  //Fin floating
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchedColumn(dataIndex);
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "fpg_id",
      key: "fpg_id",
      width: "5%",
      ...getColumnSearchProps("fpg_id"),
    },
    {
        title: "Nombre",
        dataIndex: "fpg_nombre",
        key: "fpg_nombre",
        width: "50%",
        ...getColumnSearchProps("fpg_nombre"),
      },
      {
        title: "Plazo",
        dataIndex: "fpg_plazo",
        key: "fpg_plazo",
        width: "15%",
        ...getColumnSearchProps("fpg_plazo"),
      },
      {
        title: "Mostrar",
        dataIndex: "fpg_mostrar",
        key: "fpg_mostrar",
        width: "15%",
        ...getColumnSearchProps("fpg_mostrar"),
      },
      {
        title: "Aplica Fecha",
        dataIndex: "fpg_fecha",
        key: "fpg_fecha",
        width: "10%",
        render: (text, record) => (record.fpg_fecha)?<i class="fa fa-check-circle-o" aria-hidden="true"></i>:null,
      },
    {
      title: "+",
      key: "action",
      width: "5%",
      render: (text, record) => (
        <Button
          type="primary"
          size="large"
          shape="circle"
          onClick={() => openModal(record)}
        >
          <EditOutlined />
        </Button>
      ),
    },
  ];

  // MODALES/////////////////////
  const openModal = (item) => {
    if (item) {
      setRecord(item);
    } else {
      let newRecord = {
        mrc_id: 0,
      };
      setRecord(newRecord);
    }

    setIsVisibleModal(true);
  };

  const closeModal = () => {
    setIsVisibleModal(false);
  };
  //FIN MODLAES////////////////

  const probar = () => {
    message.success("controlado", 1);
  };

  return (
    <div style={{ margin: 15 }}>
      <TitlePage title="ABM Formas de Pago" />
      <Table
        columns={columns}
        dataSource={vntformapago}
        pagination={{ pageSize: 45 }}
        scroll={{ y: window.innerHeight - 230 }}
      />
      <FloatingButtons
        buttonType="plus"
        buttonColor={"#ffffff"}
        backgroundColor={colorPrm}
        dimension={60}
        buttonsList={buttonsList}
        top={"calc(85% - 25px)"}
        left={"calc(90% - 25px)"}
        direction="circular"
        degree={-180}
        distance={100}
      />
      <ModalApp
        isVisibleModal={isVisibleModal}
        closeModal={closeModal}
        widthModal={600}
      >
        <VntFormasPagoForm
          record={record}
          closeModal={closeModal}
          currentUser={currentUser}
          varEffec={Math.random()}
        />
      </ModalApp>
    </div>
  );
}